



































































import Consent from '@/types/Consent.interface'
import SmsInboundBubble from '@/components/SmsInboundBubble.vue'
import SmsOutboundBubble from '@/components/SmsOutboundBubble.vue'
import Tenant from '@/types/Tenant.interface'
import Vue from 'vue'
export default Vue.extend({
    components: { SmsInboundBubble, SmsOutboundBubble },
    data() {
        return {
            loading: false,
            toolbar: {
                title: 'Compliance Settings',
                left: [
                    {
                        title: 'Back',
                        icon: 'mdi-chevron-left',
                        back: '/settings',
                        tooltip: 'Back',
                        permission: 0,
                        feature: null
                    }
                ],
                right: []
            },
            color: 'primary',
            editWarning: false,
            learnMoreLink: `<a target="_blank" href="https://learn.messagedesk.com/en/articles/4527080-how-messagedesk-manages-opt-in-and-opt-out-for-tcpa-compliance">Learn More</a>`,
            tempOptInMessage: null,
            tempOptOutMessage: null
        }
    },
    async mounted() {
        //  If consent is already loaded, clone it
        if (this.consent) this.cloneConsentMessages()
    },
    computed: {
        // Function pulls from api to get the settings data table to see if a user is a2p enabled or not
        A2PRegistered(): boolean {
            const a2pEnabled = this.$store.getters.settingGet('a2pEnabled')

            // Ensure that the value isn't null, if it is we don't return it
            return a2pEnabled != null
        },
        companyName(): string {
            return this.$store.getters.tenant.company_name
        },
        consent(): Consent {
            return this.$store.getters.consent
        },
        modified(): boolean {
            //  Returns bool, true if either of the opt in or opt out messages have been changed
            return (
                this.tempOptInMessage != this.consent.opt_in_message ||
                this.tempOptOutMessage != this.consent.opt_out_message
            )
        },
        supportEmail(): string {
            return this.$store.getters.tenant.support_email
        },
        tenant(): Tenant {
            return this.$store.getters.tenant
        },
        tiles() {
            return [
                {
                    title: 'Compliance Message',
                    description:
                        "Contacts receive this phrase if they aren't opted-in before receiving a text",
                    caption:
                        'Industry standards require promotional mass-texts only get sent to contacts who have explicit Opt-In',
                    type: 'compliance',
                    messages: [true, false],
                    callback: () => this.popEditOptIn()
                },
                {
                    title: 'Opt-Out Keyword: STOP',
                    description:
                        'Contacts who reply "STOP" will be unreachable by MessageDesk',
                    caption: 'MessageDesk will NOT send messages to Opted-Out Contacts',
                    type: 'stop',
                    messages: [false, true],
                    callback: () => this.popEditOptOut()
                },
                {
                    title: 'Help Keyword: HELP',
                    description:
                        'Contacts can reply HELP at anytime to get the following message',
                    caption: 'By law, all business phone lines must autorespond to HELP',
                    type: 'help',
                    messages: [false, true],
                    callback: () => this.changeEmails()
                }
            ]
        }
    },
    methods: {
        changeEmails(): void {
            //  Assemble form inputs
            const inputs = [
                {
                    type: 'TEXT',
                    name: 'Organization Name',
                    label: 'Organization Name',
                    icon: 'mdi-format-size',
                    path: 'company_name',
                    validate: 'required|max:45'
                },
                {
                    type: 'TEXT',
                    name: 'Support Email',
                    label: 'Support Email',
                    icon: 'mdi-format-size',
                    path: 'support_email',
                    validate: 'required|max:191|email'
                }
            ]
            //  Pop an app-form dialog
            this.$store.dispatch('dialogOpen', {
                type: 'APP',
                title: 'Edit Organization',
                component: 'app-form',
                color: 'primary',
                closeable: true,
                props: {
                    color: 'primary',
                    model: this.tenant,
                    inputs: inputs
                },
                callback: (tenant: Tenant): void => this.organizationUpdate(tenant)
            })
        },
        cloneConsentMessages(): void {
            //  Set a temp variable for the current opt in message changes
            this.tempOptInMessage = this.consent.opt_in_message

            //  Set a temp variable for the current opt out message changes
            this.tempOptOutMessage = this.consent.opt_out_message
        },
        keywordMsg(type: string): object {
            const object = [
                {
                    text: `<div style="font-size:12px;">${this.tempOptInMessage}</div>`,
                    type: 'compliance',
                    key: 'compliance'
                },
                {
                    text: `<div style="font-size:12px;">${this.tempOptOutMessage}</div>`,
                    type: 'compliance',
                    key: 'stop'
                },
                {
                    text: `<div style="font-size:12px;">${this.companyName}: For help, email 
                        ${this.supportEmail}.\nReply STOP to Opt-Out</div>`,
                    type: 'compliance',
                    key: 'help'
                },
                {
                    text: '<span style="font-size:12px;">Example Text Message</span>',
                    type: 'compliance',
                    key: 'register'
                }
            ]
            const selectedObject = object.find((x) => x.key === type)

            return selectedObject
        },
        async organizationUpdate(tenant: Tenant): Promise<void> {
            //  Start the loading spinner
            this.loading = true

            //  Update the tenant
            const success = await this.$store.dispatch('tenantPut', tenant)

            //  Stop the loading spinner
            this.loading = false

            //  If the request failed, no nothing
            if (!success) return

            //  Else, close dialog
            this.$store.dispatch('dialogClose', 'APP')

            //  Pop notification
            this.$store.commit('appNotificationBarSet', {
                message: 'Organization Updated',
                type: 'success'
            })
        },
        personMsg(type: string): object {
            const object = [
                {
                    text: '<span style="font-size:12px;">Subscribe</span>',
                    type: 'compliance'
                },
                {
                    text: '<span style="font-size:12px;">STOP</span>',
                    type: 'stop'
                },
                {
                    text: '<span style="font-size:12px;">HELP</span>',
                    type: 'help'
                }
            ]
            const selectedObject = object.find((x) => x.type === type)

            return selectedObject
        },
        popEditOptIn(): void {
            this.$store.dispatch('dialogOpen', {
                type: 'APP',
                title: 'Compliance Message',
                component: 'message-text-form-save',
                color: 'primary',
                closeable: true,
                closeOnSubmit: true,
                width: '600px',
                props: {
                    insert: this.tempOptInMessage
                },
                callback: (message: string): void => {
                    //  Set Opt in message to temp variable
                    this.tempOptInMessage = message

                    //  Update the message
                    this.updateConsentMessages()
                }
            })
        },
        popEditOptOut(): void {
            this.$store.dispatch('dialogOpen', {
                type: 'APP',
                title: 'Opt-Out Keyword: STOP',
                component: 'message-text-form-save',
                color: 'primary',
                closeable: true,
                closeOnSubmit: true,
                width: '600px',
                props: {
                    insert: this.tempOptOutMessage
                },
                callback: (message: string): void => {
                    //  Set Opt Out message to temp variable
                    this.tempOptOutMessage = message

                    //  Update the message
                    this.updateConsentMessages()
                }
            })
        },
        async updateConsentMessages(): Promise<void> {
            //  Validate the opt in and opt out messages
            const valid = await this.$validator.validateAll()

            //  If not valid, return
            if (!valid) return

            //  Create payload to save opt messages
            const payload = {
                opt_in_message: this.tempOptInMessage,
                opt_out_message: this.tempOptOutMessage
            }

            //  Start the loading spinner
            this.loading = true

            //  Dispatch api request to save the messages to the tenant's sms account
            const consent = await this.$store.dispatch('consentPut', payload)

            //  Stop the loading spinner
            this.loading = false

            //  If request failed, return
            if (!consent) return

            //  Update the sms account in the client store
            this.$store.commit('consentSet', consent)

            //  Confirmation app notification bar
            this.$store.commit('appNotificationBarSet', {
                message: 'Opt Messages Updated.'
            })
        },
        async updateConsentSettings(bool: boolean): Promise<void> {
            //  Give pop-up warning if boolean is false (i.e they turned this setting off) that all messages require opt-out and having this off may affect delivery 
            if (!bool) {
                this.$store.dispatch('dialogOpen', {
                    type: 'MESSAGE',
                    title: 'Message Compliance',
                    text: 'WARNING: All Messages Require Opt-Out Verbiage, Turning This Setting Off May Affect Delivery',
                    icon: 'mdi-alert',
                    color: 'primary',
                    closeable: true
                })
            }

            //  Assemble the API payload
            const payload = { append_all: bool }

            //  Start the loading spinner
            this.loading = true

            //  Send the changes to the server
            await this.$store.dispatch('consentPut', payload)

            //  Stop the loading spinner
            this.loading = false
        }
    },
    watch: {
        consent(): void {
            this.cloneConsentMessages()
        }
    }
})
